// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.6_@swc+helpers@0.5.17__webpack@5.99.9_@swc+core@1.13.3_@swc_mnajo7653pvs7gytgvlwvpbsca/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@1.5.6_@swc+helpers@0.5.17__webpack@5.99.9_@swc+core@1.13.3_@swc_mnajo7653pvs7gytgvlwvpbsca/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapboxgl-popup-content {
    border-radius: 1rem !important;
}

.mapboxgl-popup-close-button {
    top: 3px !important;
    font-size: 2rem;
}

.empty-popup .mapboxgl-popup-content {
    background: none;
    padding: 0;
}
.empty-popup .mapboxgl-popup-tip {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/map.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,aAAa;AACjB","sourcesContent":[".mapboxgl-popup-content {\n    border-radius: 1rem !important;\n}\n\n.mapboxgl-popup-close-button {\n    top: 3px !important;\n    font-size: 2rem;\n}\n\n.empty-popup .mapboxgl-popup-content {\n    background: none;\n    padding: 0;\n}\n.empty-popup .mapboxgl-popup-tip {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
